import { useRouter } from 'next/router'
import LottieControl from 'projects/kyc-2/widgets/common-image/lottie'

type TProps = {
  lottieUrl: string
  preserveAspectRatio?: string
  loop?: boolean | number
  speed?: number
  width?: number
  height?: number
  className?: string
  navlink?: string
}

const mweb = !!(typeof window !== 'undefined' && window.innerWidth < 568)

const StrapiV4Lottie = (props: TProps) => {
  const { lottieUrl, width, height, navlink, ...rest } = props

  const router = useRouter()

  return (
    <div
      style={{
        height,
      }}
      className="w-auto lg:w-fit"
      onClick={() => {
        if (navlink) void router.push(navlink)
      }}
    >
      <LottieControl
        props={{
          lottie: lottieUrl,
          width: mweb ? 'auto' : width,
          height,
          ...rest,
        }}
      />
    </div>
  )
}

export default StrapiV4Lottie
